import { BODY_FONT_PT, FONT_SIZES } from '@root/helpers/editor';

import type { Option } from '../types';

const isFontSize = (editor: any, fontSize: string | number) => {
  const textHasOwnSize = Boolean(editor?.getAttributes('textStyle').fontSize);
  return editor?.isActive(textHasOwnSize ? 'textStyle' : 'paragraph', { fontSize });
};

const setSize = (editor: any, fontSize: string | number) => {
  const isActive = isFontSize(editor, fontSize);

  if (isActive) return editor?.chain().focus().unsetFontSize().run();

  return editor?.chain().focus().setFontSize(fontSize).run();
};

export const getFontSizeCtrlOptions = (editor: any, onSelected: () => void): Option[] =>
  FONT_SIZES.map(({ pt, name }) => {
    const size = `${pt}pt`;
    return {
      format: () => {
        setSize(editor, size);
        return onSelected();
      },
      isActive: isFontSize(editor, size),
      key: name,
      icon: <span>{name}</span>,
      title: `Set font size to ${size}.${pt === BODY_FONT_PT ? ' Default.' : ''}`,
    };
  });
